import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { showError } from '@utils';
import { FILTER_RULE_ENUMS, LIMIT } from '@constants';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import { roadsideAssistanceServices } from '@services';
import { handleRoadsideAssistancesData } from './utils';

export const ROAD_ASSISTANCE_PAGE_SIZE = LIMIT;
const EMPTY_RULE = {
  type: FILTER_RULE_ENUMS.EmptyRuleType,
};
export const useRoadsideAssistancesOperations = () => {
  const { query, isReady } = useRouter();

  const {
    page = 1,
    pageSize = ROAD_ASSISTANCE_PAGE_SIZE,
    orderBy = 'internalId',
    order = 'asc',
    query: searchQuery = '',
  } = query;

  const roadsideAssistancesResponse = useQuery(
    [
      QUERY_KEYS.GET_ROADSIDE_ASSISTANCES_KEY,
      {
        page,
        pageSize,
        order,
        orderBy,
        query: searchQuery,
      },
    ],
    () =>
      roadsideAssistanceServices.filterRoadsideAssistances({
        params: {
          page,
          pageSize: parseInt(pageSize, 10) || ROAD_ASSISTANCE_PAGE_SIZE,
          order,
          orderBy,
          query: searchQuery,
        },
        payload: EMPTY_RULE,
      }),
    { enabled: isReady }
  );

  const roadsideAssistances = handleRoadsideAssistancesData(
    roadsideAssistancesResponse?.data?.data || []
  );

  useEffect(() => {
    if (roadsideAssistancesResponse?.error) {
      showError(roadsideAssistancesResponse?.error);
    }
  }, [roadsideAssistancesResponse?.error]);

  return {
    page,
    pageSize: parseInt(pageSize, 10) || ROAD_ASSISTANCE_PAGE_SIZE,
    total: roadsideAssistancesResponse?.data?.meta?.total,
    loading: roadsideAssistancesResponse?.isLoading,
    roadsideAssistances,
    getRoadsideAssistances: roadsideAssistancesResponse.refetch,
  };
};
